import { TwoFactorChallengeResponse } from 'entities/Auth/api/types';
import { create } from 'zustand';

type TwoFactorStore = {
	challenge: TwoFactorChallengeResponse | null;
	backupCodes: string[] | null;
};

type TwoFactorActions = {
	setChallenge: (challenge: TwoFactorChallengeResponse) => void;
	completeSetup: (backupCodes: string[]) => void;
	reset: () => void;
};

const initialState: TwoFactorStore = {
	challenge: null,
	backupCodes: null,
};

const twoFactorStore = create<TwoFactorStore & TwoFactorActions>()((set) => ({
	...initialState,
	setChallenge: (challenge) => set(() => ({ challenge })),
	completeSetup: (backupCodes) => set(() => ({ challenge: null, backupCodes })),
	reset: () => set(() => ({ ...initialState })),
}));

export const useTwoFactorStore = () => twoFactorStore((state) => state);
